export { useGetRouterQuerySlug } from './useGetRouterQuerySlug';
